export function IconButton({
  type = 'button',
  title,
  'aria-label': ariaLabel,
  className = '',
  children,
  ...props
}) {
  const base =
    'inline-flex items-center justify-center p-2 rounded-full border-2 border-slate-100 bg-white text-slate-500 hover:text-slate-700 hover:bg-slate-50 transition-colors dark:bg-slate-950 dark:border-slate-800 dark:text-slate-300 dark:hover:bg-slate-900 dark:hover:text-slate-100'

  return (
    <button type={type} title={title} aria-label={ariaLabel} className={`${base} ${className}`.trim()} {...props}>
      {children}
    </button>
  )
}

